// Scrolls an outline's target into view and pulses it, for both the builder and
// the read-only submission view. Shared because of the scroll-parent subtlety
// below, which is easy to lose in a second copy.

// Deliberately not Element.scrollIntoView(): it walks every scrollable ancestor,
// including the app shell's overflow-hidden `w-dvw h-dvh` wrapper, which it will
// shove up by ~header-height — hiding the top bar and leaving a gap at the bottom
// that cannot be scrolled back. Scrolling only the nearest scroll parent keeps
// the shell put.
function scrollParent(el: HTMLElement): HTMLElement | null {
  let node = el.parentElement;
  while (node) {
    const overflowY = getComputedStyle(node).overflowY;
    if (
      (overflowY === "auto" || overflowY === "scroll") &&
      node.scrollHeight > node.clientHeight
    ) {
      return node;
    }
    node = node.parentElement;
  }
  return null;
}

// Matches the cf-jump-pulse animation the anchor targets declare.
const PULSE_MS = 1200;

export function useOutlineScroll() {
  function scrollToAnchor(selector: string) {
    const el = document.querySelector(selector) as HTMLElement | null;
    if (!el) return;

    const scroller = scrollParent(el);
    if (scroller) {
      const top =
        scroller.scrollTop +
        (el.getBoundingClientRect().top -
          scroller.getBoundingClientRect().top) -
        8;
      scroller.scrollTo({ top, behavior: "smooth" });
    } else {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    el.classList.add("cf-jump-pulse");
    window.setTimeout(() => el.classList.remove("cf-jump-pulse"), PULSE_MS);
  }

  return {
    scrollToAnchor,
    jumpToSection: (key: string | number) =>
      scrollToAnchor(`[data-cf-section-key="${key}"]`),
    jumpToQuestion: (key: string | number) =>
      scrollToAnchor(`[data-cf-question-key="${key}"]`)
  };
}
